import React from 'react';
import { DataGridLayout, RelatedList, RelationListLayout } from 'framework/list';
import useVacancyPublicationService from 'domain/recruiting/newVacancy/show/publications/vacancyPublicationService';
import { BadgeField, DateField } from 'framework/ui/field';
import PublicationPlatformField from 'domain/recruiting/newVacancy/show/publications/field/PublicationPlatformField';
import { ShowSection } from 'framework/ui/layout';
import ViewVacancyPublicationButton from '../shared/button/ViewVacancyPublicationButton';
import PublicationLinkField from '../field/PublicationLinkField';
import CreateVacancyPublicationButton from '../shared/button/CreateVacancyPublicationButton';
import StatusBadge from 'domain/recruiting/newVacancy/show/publications/shared/badge/StatusBadge';

const RelatedPublicationsList = () => {
  const { search } = useVacancyPublicationService();

  return (
    <RelatedList getDataMethod={search}>
      <ShowSection>
        <RelationListLayout actions={[<CreateVacancyPublicationButton />]}>
          <DataGridLayout buttons={[<ViewVacancyPublicationButton source="id" />]} isSmallTable showTotal={false}>
            <PublicationPlatformField source="type" label="Platform" />
            <BadgeField
              width={100}
              isSortable
              badges={[<StatusBadge idSource="id" statusSource="status" />]}
              label="Status"
              source="status"
            />
            <PublicationLinkField label="Publication" />
            <DateField source="createdAt" label="Create date" />
            <DateField source="updatedAt" label="Modification date" />
          </DataGridLayout>
        </RelationListLayout>
      </ShowSection>
    </RelatedList>
  );
};

export default RelatedPublicationsList;
